import { NO_DATA } from "@/constants";
import { useTranslation } from "react-i18next";

interface TaxStatusProps {
  value?: string | null;
  className?: string;
}

export default function TaxStatus({ value, className }: TaxStatusProps) {
  const { t } = useTranslation();

  if (!value) return NO_DATA;

  return (
    <span className={`flex items-center gap-1 ${className || ""}`}>
      {t(`taxStatus.${value}`)}
    </span>
  );
}
